var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenWaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#C0D20F",
    strokeWidth: 4,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2c7 0 7 7.806 13.999 7.806 7 0 7-7.806 14-7.806S37 9.806 44 9.806M2 17.194C9 17.194 9 25 15.999 25c7 0 7-7.806 14-7.806S37 25 44 25"
  }))));
}

export default SvgGreenWaves;